import { render, staticRenderFns } from "./LessonVideosWidget.vue?vue&type=template&id=b9944e78&scoped=true"
import script from "./LessonVideosWidget.vue?vue&type=script&lang=js"
export * from "./LessonVideosWidget.vue?vue&type=script&lang=js"
import style0 from "./LessonVideosWidget.vue?vue&type=style&index=0&id=b9944e78&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9944e78",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b9944e78')) {
      api.createRecord('b9944e78', component.options)
    } else {
      api.reload('b9944e78', component.options)
    }
    module.hot.accept("./LessonVideosWidget.vue?vue&type=template&id=b9944e78&scoped=true", function () {
      api.rerender('b9944e78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Widgets/LessonVideosWidget.vue"
export default component.exports